import apiUrl from 'common/api-url';
import { xhr } from 'common/xhr';

export type RescheduleRestrictionLevel = 'NONE' | 'REASON_REQUIRED' | 'BLOCKED';

export type RescheduleRestrictionsResponse = {
  restrictionLevel: RescheduleRestrictionLevel;
};

export type CheckRescheduleRestrictionsParams = {
  appointmentIds?: number[];
  appointmentGroupIds?: number[];
};

/**
 *  Ask the backend whether the given appointments/appointment groups are
 *  allowed to be rescheduled, and if not, what's needed to proceed.
 *
 *  @returns {$.Promise} Resolves with { restrictionLevel: 'NONE' | 'REASON_REQUIRED' | 'BLOCKED' }
 */
export default function checkRescheduleRestrictions(_params: CheckRescheduleRestrictionsParams) {
  const payload: CheckRescheduleRestrictionsParams = {};
  if (_params.appointmentIds?.length) {
    payload.appointmentIds = _params.appointmentIds;
  }
  if (_params.appointmentGroupIds?.length) {
    payload.appointmentGroupIds = _params.appointmentGroupIds;
  }

  return xhr.postWithPromise(apiUrl('RESCHEDULE_RESTRICTIONS'), payload);
}
